export const renderParagraphs = (
  text: string | undefined,
  separator = "^"
): JSX.Element[] => {
  if (!text) return [];

  return text
    .split(separator)
    .map((sentence, idx) => {
      const trimmed = sentence.trim();
      if (!trimmed) return null;

      return <p key={idx}>{trimmed}</p>; // ✅ 올바른 JSX 문법
    })
    .filter((el): el is JSX.Element => el !== null); // ✅ null 제거 + 타입 가드
};

export const formatDate = (dateStr: string) => {
  const date = new Date(dateStr);
  if (isNaN(date.getTime())) return "-";

  const yyyy = date.getFullYear();
  const mm = String(date.getMonth() + 1).padStart(2, "0");
  const dd = String(date.getDate()).padStart(2, "0");
  const hh = String(date.getHours()).padStart(2, "0");
  const min = String(date.getMinutes()).padStart(2, "0");
  const ss = String(date.getSeconds()).padStart(2, "0");

  return `${yyyy}-${mm}-${dd} ${hh}:${min}:${ss}`;
};

// 전화번호 자동 포맷팅 (010-1234-5678 형태)
export const formatPhoneNumber = (value: string): string => {
  // 숫자만 추출
  let onlyNums = value.replace(/[^0-9]/g, "");

  // 11자리 초과 시 잘라내기
  if (onlyNums.length > 11) {
    onlyNums = onlyNums.slice(0, 11);
  }

  if (onlyNums.length > 7) {
    // 010-1234-5678
    return onlyNums.replace(/(\d{3})(\d{4})(\d{0,4})/, "$1-$2-$3");
  } else if (onlyNums.length > 3) {
    // 010-1234
    return onlyNums.replace(/(\d{3})(\d{0,4})/, "$1-$2");
  } else {
    return onlyNums;
  }
};

export const clearLocalStorageExceptSavedLoginInfo = () => {
  const savedLoginInfo = localStorage.getItem("savedLoginInfo");

  localStorage.clear();

  if (savedLoginInfo) {
    localStorage.setItem("savedLoginInfo", savedLoginInfo);
  }
};
